import { render } from "./Overview.vue?vue&type=template&id=634abf5a"
import script from "./Overview.vue?vue&type=script&lang=ts"
export * from "./Overview.vue?vue&type=script&lang=ts"
script.render = render

export default script